// extracted by mini-css-extract-plugin
export default {"actions_box_container":"Tabs_actions_box_container__Djn0H","actions_box":"Tabs_actions_box__mMfV7","action_box":"Tabs_action_box__VZLf0","active":"Tabs_active__1fVDZ"};